import { ArrowUpDown } from 'lucide-react'

import { IconActionButton, IconActionButtonProps } from './icon-action-button'

const Component = (props: IconActionButtonProps) => (
  <IconActionButton
    icon={ArrowUpDown}
    tooltip="Nova transação"
    aria-label="Transação"
    {...props}
  />
)

export default Component
